module.exports = __webpack_public_path__ + "img/pr-28.51f061a6.png";